import { baseThemeData } from "./baseTheme";

const basePokerThemeData = {
  ...baseThemeData,
  colors: {
    ...baseThemeData.colors,
    brandColor: "#0370dd",
    currentBalanceColor: "#FCE403"
  }
};

const computePanelThemeData = () => {
  return {
    panel: {
      header: {
        icon: { defaultColor: "#717171" },
        title: {
          defaultColor: basePokerThemeData.textColor
        },
        description: {
          defaultColor: basePokerThemeData.colors.brandColor
        }
      }
    }
  };
};

const computeExpandablePanelThemeData = () => {
  return {
    expandablePanel: {
      before: {
        borderTopColor: "#2c2c2c",
        boxShadow: "0px -1px 0px 0px",
        boxShadowColor: "#171717"
      },
      header: {
        icon: { defaultColor: "#717171" },
        title: {
          defaultColor: basePokerThemeData.textColor,
          expandedColor: basePokerThemeData.colors.brandColor
        },
        arrow: {
          defaultColor: basePokerThemeData.textColor,
          expandedColor: basePokerThemeData.colors.brandColor
        }
      }
    }
  };
};

const computeListThemeData = () => {
  return {
    list: {
      item: {
        borderBottomColor: basePokerThemeData.backgrounds.mainBG,
        text: { defaultColor: "#cccccc" },
        checkbox: {
          checkedBackground: basePokerThemeData.colors.brandColor,
          unCheckedBackground: "#000000",
          defaultColor: basePokerThemeData.colors.brandColor
        }
      }
    }
  };
};

const computeCheckboxListThemeData = () => {
  return {
    checkboxList: {
      title: {
        defaultColor: "#cccccc",
        borderBottomColor: basePokerThemeData.backgrounds.mainBG
      }
    }
  };
};

const computeDrawerThemeData = () => {
  return {
    drawer: {
      header: {
        backgroundColor: "#0a0a0a"
      },
      area: { background: basePokerThemeData.backgrounds.mainBG },
      box: { background: basePokerThemeData.backgrounds.boxBG }
    }
  };
};

const computeLinkButtonThemeData = () => {
  return {
    linkButtonTitle: {
      defaultColor: "#cccccc",
      borderBottomColor: basePokerThemeData.backgrounds.mainBG
    },
    linkButton: {
      icon: { defaultColor: "#717171" },
      title: { defaultColor: basePokerThemeData.colors.textColor },
      description: {
        defaultColor: basePokerThemeData.colors.brandColor
      },
      arrow: {
        defaultColor: "#ffffff"
      }
    }
  };
};

const getHeaderButtonPcStyles = () => {
  return {
    ...basePokerThemeData,
    colors: {
      ...basePokerThemeData.colors,
      textColorBtnOutlined: "#007CF7",
      outlinedBorderColor: "#0370dd"
    },
    typography: {
      ...basePokerThemeData.typography,
      fontSize: `1.4rem`,
      fontWeight: 900
    },
    backgrounds: {
      ...basePokerThemeData.backgrounds,
      hoverColorOutlined: basePokerThemeData.colors.brandColor
    },
    borders: {
      ...basePokerThemeData.borders,
      borderColor: "#0370dd",
      borderColorMobile: "#0370dd"
    }
  };
};

const computeLinkItemThemeData = () => {
  return {
    linkItem: {
      icon: { defaultColor: basePokerThemeData.colors.iconColor }
    }
  };
};

const computePopupThemeData = () => {
  return {
    popupButton: {
      fontFamily: "defaultBold",
      dotsFloatingBackgroundColor: "#0A0A0A",
      outlined: {
        background: "#0270dd",
        backgroundColor: "#000000",
        color: "#ffffff",
        borderColor: "#6c6c6c",
        hover: {
          backgroundColor: "#0270dd",
          color: "#ffffff",
          borderColor: "#ffffff"
        }
      },
      contained: {
        background: "#0270dd",
        color: "#ffffff",
        borderColor: "#0270dd",
        hover: {
          background: "#000000",
          color: "#0270dd",
          borderColor: "#0270dd"
        }
      },
      underlined: {
        color: "#ffffff",
        hover: {
          background: "none",
          color: "#ffffff"
        }
      }
    },
    popupContainer: {
      textColor: "#0370dd",
      subtitleColor: "#0270dd",
      message: {
        color: "#0270dd"
      },
      zIndex: 10000,
      backgroundColor: "#111111",
      titleBackgroundColor: "#232323",
      iconColor: "#0370dd",
      pokerDownloadGuide: {
        titleWrapperColor: "#0370dd",
        underlineTextWrapperColor: "#0370dd",
        svgWrapperColor: "#0370dd"
      }
    },
    popupFooter: {
      fontFamily: "defaultMedium",
      color: "#a5a5a5"
    }
  };
};

const computeControlCenterThemeData = () => {
  return {
    controlCenter: {
      headerButton: {
        backgroundColor: "#121212",
        borderColor: "#4c4c4c",
        svgBackgroundColor: "#6c6c6c"
      }
    }
  };
};

const computeLanguagesDrawerThemeData = () => {
  return {
    languagesDrawer: {
      fontFamily: "defaultDemibold",
      checkedOptionBackgroundColor: "0370dd",
      backgroundColor: "#171717",
      textColor: "#FFFFFF"
    }
  };
};

export const PokerThemeData = {
  getHeaderButtonPcStyles,
  ...basePokerThemeData,
  ...computePanelThemeData(),
  ...computeExpandablePanelThemeData(),
  ...computeDrawerThemeData(),
  ...computeListThemeData(),
  ...computeCheckboxListThemeData(),
  ...computeLinkButtonThemeData(),
  ...computeLinkItemThemeData(),
  ...computePopupThemeData(),
  ...computeControlCenterThemeData(),
  ...computeLanguagesDrawerThemeData()
};
